import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, useContext, useEffect, useState } from "react";
import { AuthContext } from "../contexts/auth";
import { Link } from 'wouter';
import ChangePasswordForm from "../components/change_password_form";
import EditProfileForm from '../components/edit_profile_form';
import ChooseConsulente from '../components/choose_consulente';
import TourUtente from '../components/tour_utente';
import { changePassword } from '../services/api';
import LocationsCompanyForm from '../components/locations_company_form';
import Swal from 'sweetalert2';
import { deleteLocationCompany, updateLocationCompany, createLocationCompany } from '../services/api_company_locations';
import PopoverComponentCustom from '../components/popover_component';
import { getSubscriptions } from '../services/api_subscriptions';



export default function Profile() {

  const { profile, token, setProfile } = useContext(AuthContext)
  const [open, setOpen] = useState(false)
  const [fetching, setFetching] = useState(true)
  const [profileData, setProfileData] = useState({})
  const [company, setCompany] = useState(profile.profile)
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [subscriptions, setSubscriptions] = useState([]);
  const [isLoadingSubscriptions, setIsLoadingSubscriptions] = useState(false);
  const [subscriptionsError, setSubscriptionsError] = useState(null);

  const isProfileComplete = profile.has_complete_profile;

  const hasNoPlan = profile?.level?.no_plan?.length === 0; 

  
  // FUNZIONE PRECEDENTE DI REFRESH, LASCIO COMMENTATA

  // const refresh = (data) => {
  //   Object.keys(data).forEach((key) => {
  //     setCompany((prevState) => ({
  //       ...prevState,
  //       [key]: data[key]
  //     }))
  //   })
  // }

  const refresh = (data) => {
    // Aggiorna lo stato `company` con i nuovi dati
    setCompany(data.profile);
  };

  useEffect(() => {
    // Sincronizza `company` con i dati del contesto `profile`
    setCompany(profile.profile);
  }, [profile]);

  
  return (
    <>
    <div className="min-h-full">
      <PopoverComponentCustom title="Profilo" />
      {(profile?.customer_type === 'company' && !isProfileComplete && company?.email_auth == profile?.the_real_user_email) && (
        <div className="w-full">
          <div className="bg-orange-100 text-orange-600 p-4">
            <p className="text-center text-sm font-semibold">
              Il profilo non è completo. <br />
              Compila i campi mancanti{' '}
              <Link
                to="/profilo/fatturazione"
                className="text-indigo-600 hover:text-indigo-800 underline"
              >
                cliccando qui
              </Link>
              .
            </p>
          </div>
        </div>
      )}
      <main className="mt-10 pb-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full md:w-2/3 px-4 mb-5 firstStepProfilo">
              <div className="overflow-hidden bg-white shadow sm:rounded-lg">
                <div className="px-4 py-6 sm:px-6 flex justify-between">
                  <div>
                    <h3 className="text-base font-semibold leading-7 text-gray-900">{company?.business_name}</h3>
                    <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">{company?.cf}</p>
                  </div>
                  <div>
                    <button
                      type="button"
                      onClick={() => {
                        if (hasNoPlan) {
                          Swal.fire({
                            icon: "warning",
                            title: "Sottoscrizione richiesta",
                            text: "Per eseguire questa azione è necessario avere una sottoscrizione attiva.",
                            confirmButtonText: "OK"
                          });
                        } else {
                          setOpen(true);
                        }
                      }}
                      className="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:bg-gray-400 disabled:cursor-not-allowed"
                    >
                      Modifica
                    </button>
                  </div>
                </div>
                <div className="border-t border-gray-100">
                  <dl className="divide-y divide-gray-100">
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-900">Codice Azienda</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {company?.id}
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-900">Partita IVA</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {company?.piva}
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-900">Legale Rappresentante Cognome</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {company?.legal_surname}
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-900">Legale Rappresentante Nome</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {company?.legal_name}
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-900">Indirizzo</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 uppercase">
                        {company?.address}, {company?.cap} - {company?.city_name}
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-900">Email</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {company?.email_auth}
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-900">PEC</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {company?.pec ? company.pec : 'Non presente'}
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-900">Telefono</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {company?.phone_number ? company.phone_number : 'Non presente'}
                      </dd>
                    </div>
                    {/* <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-900">Legale Rappresentante</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {company.legal_name} {company.legal_surname}
                      </dd>
                    </div> */}
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-900">ID Gestionale Esterno</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {company?.external_reference ? company.external_reference : ''}
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-900">Logo</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <img src={company?.logo_url} alt="" style={{maxWidth: 150}}/>
                      </dd>
                    </div>

                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-900"></dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        <button
                          type="button"
                          onClick={() => {
                            if (hasNoPlan) {
                              Swal.fire({
                                icon: "warning",
                                title: "Sottoscrizione richiesta",
                                text: "Per eseguire questa azione è necessario avere una sottoscrizione attiva.",
                                confirmButtonText: "OK"
                              });
                            } else {
                              setOpen(true);
                            }
                          }}
                          className="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:bg-gray-400 disabled:cursor-not-allowed"
                        >
                          Modifica
                        </button>
                      </dd>
                    </div>


                    <Transition.Root show={open} as={Fragment}>
                      <Dialog as="div" className="relative" style={{ zIndex: 200 }} onClose={() => {}}>
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0"
                          enterTo="opacity-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                        >
                          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                              as={Fragment}
                              enter="ease-out duration-300"
                              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                              enterTo="opacity-100 translate-y-0 sm:scale-100"
                              leave="ease-in duration-200"
                              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-6 pt-6 text-left shadow-xl transition-all my-20 xl:my-8 w-3/4">
                                <button
                                  type="button"
                                  onClick={() => setOpen(false)}
                                  className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 focus:outline-none"
                                >
                                  <span className="sr-only">Chiudi</span>
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                  </svg>
                                </button>  
                                <div>
                                  <EditProfileForm data={profile} token={token} close={() => setOpen(false)} refresh={refresh} />
                                </div>
                                <div className="mt-5 sm:mt-6">
                                  
                                </div>
                              </Dialog.Panel>
                            </Transition.Child>
                          </div>
                        </div>
                      </Dialog>
                    </Transition.Root>
                  </dl>
                </div>
              </div>
            </div>

            <div className="w-full md:w-1/3 px-4">
              {(company?.email_auth == profile?.the_real_user_email) && (
                <div className="overflow-hidden bg-white shadow sm:rounded-lg p-4">
                  <h3 className="text-base font-semibold leading-7 text-gray-900">Cambia Password</h3>
                  <ChangePasswordForm updateFunction={changePassword} />
                </div>
              )}
              {!hasNoPlan && profile?.customer_type === 'company' && company?.email_auth === profile?.the_real_user_email && (
                <div className="overflow-hidden bg-white shadow sm:rounded-lg p-4 my-4 secondStepProfilo nextStep5">
                  <h3 className="text-base font-semibold leading-7 text-gray-900">Collega un consulente</h3>
                  <ChooseConsulente 
                    profile={profile}
                    token={token} 
                  />
                </div>
              )}
            </div>
          </div>
          <LocationsCompanyForm
            profile={profile}
            token={token}
          />
        </div>            
      </main>
    </div>
    </>
  )
}